import { takeLatest, put, call } from "redux-saga/effects";
import { getRegistration } from "../../helpers/backend_helper";
import { getRegistrationFailed, getRegistrationSuccess } from "./actions";
import { GET_REGISTRATION } from "./actionsTypes";

function* onPostRegistration({ payload: params }) {
  try {
    const response = yield call(getRegistration, params);
    yield put(getRegistrationSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(getRegistrationFailed(error.response));
  }
}

function* RegistrationSaga() {
  yield takeLatest(GET_REGISTRATION, onPostRegistration);
}

export default RegistrationSaga;
